import { render, staticRenderFns } from "./EconomicSector.vue?vue&type=template&id=bec8dfcc&"
import script from "./EconomicSector.vue?vue&type=script&lang=js&"
export * from "./EconomicSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports